import React, { Component } from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import {
  getEntryTypes,
  getEntrySubTypes,
  saveSingle,
} from "../../services/generalLedgerService";
import { toast } from "react-toastify";

import BlockUi from "react-block-ui";
import { Table, Button, Message, Label } from "semantic-ui-react";
import TableTitle from "../common/tableTitle";
import auth from "../../services/authService";
import Companies from "../company/companies";
import DatePicker from "react-datepicker";

class GeneralLedgerEntry extends Form {
  state = {
    imageUrl: false,
    entryTypes: [],
    entrySubTypes: [],
    companies: [],
    accounts: [],
    todayDate: new Date(),
    paymentDate: new Date(),
    showSubType: false,
    field: "",
    value: "",
    data: {
      company: "",
      type: "",
      subtype: "",
      account: "",
      amount: "",
      description: "",
    },
    errors: {},
  };

  schema = {
    id: Joi.string(),
    company: Joi.string().required().label("Company"),
    type: Joi.string().required().label("Type"),
    subtype: Joi.string().required().label("Sub Type"),
    account: Joi.string().allow("").label("Account"),
    amount: Joi.number().required().label("Amount"),
    description: Joi.string().required().label("Description"),
  };

  handleChangePaymentDate = (date) => {
    this.setState({
      paymentDate: date,
    });
  };

  async componentDidMount() {
    this.setState({ blocking: true });
    const { data: res } = await getEntryTypes();

    this.setState({
      blocking: false,
      entryTypes: res.types,
      companies: res.companies,
    });
  }

  validateLogic() {
    const { company, type } = this.state.data;

    if (
      (type === "room" ||
        type === "vehicle" ||
        type === "visa" ||
        type === "yard" ||
        type === "expense") &&
      (company === "" || company === "-1")
    ) {
      alert("Please select company.");
      return false;
    }

    if (type === "account" && company != "-1") {
      alert("Please select no company option.");
      return false;
    }

    return true;
  }

  doSubmit = async () => {
    if (this.validateLogic()) {
      try {
        this.setState({ blocking: true });

        // const data = { ...this.state.data };
        // var event = new Date(this.state.paymentDate);
        // let date = JSON.stringify(event);
        // date = date.slice(1, 11);
        // //data.payment_date = date;

        let formData = new FormData();
        formData.append("company", this.state.data.company);
        formData.append("type", this.state.data.type);
        formData.append("subtype", this.state.data.subtype);
        formData.append("account", this.state.data.account);
        formData.append("amount", this.state.data.amount);
        formData.append("description", this.state.data.description);
        formData.append("attachment", this.state.imageUrl);

        await saveSingle(formData);
        toast.success("Entry has been added successfully.");
        this.setState({ blocking: false });
        this.props.history.push("/report/general-ledger");
      } catch (ex) {
        console.log(ex.response);
        if (ex.response && ex.response.status === 422) {
          const errors = { ...this.state.errors };

          if (ex.response.data.errors.visa_id)
            errors.expense_type_id = ex.response.data.errors.expense_type_id;

          if (ex.response.data.errors.description)
            errors.description = ex.response.data.errors.description;

          if (ex.response.data.errors.cost)
            errors.cost = ex.response.data.errors.cost;
          this.setState({ errors, blocking: false });
          //toast.warning("check validation errors.");
        }
      }
    }
  };

  doChange = async (field, value) => {
    if (field === "type") {
      this.setState({ blocking: true });
      const params = {
        company: this.state.data.company,
        entryType: value,
      };
      const { data: res } = await getEntrySubTypes(params);
      this.setState({
        blocking: false,
        entrySubTypes: res.subTypes,
        accounts: res.accounts,
      });
    }
  };

  onChangeFile = (e) => {
    let files = e.target.files || e.dataTransfer.files;
    if (!files.length) return;
    this.setState({ imageUrl: files[0] });
    //this.createImage(files[0]);
  };

  render() {
    if (auth.getCurrentUser().role != "client") {
      return "Your are authorized to perform this action.";
    }
    const { showSubType } = this.state;
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <h1 className="container__heading">Add ledger</h1>

        <form onSubmit={this.handleSubmit}>
          <div className="card form">
            <div className="form__content">
              <h3 className="card__heading">Add ledger</h3>
              <p>Provide the information below to add the ledger.</p>
              {this.renderSelect("company", "Company", this.state.companies)}
              {this.renderSelect("type", "Entry Type", this.state.entryTypes)}
              {this.renderSelect(
                "subtype",
                "Sub Type",
                this.state.entrySubTypes
              )}
              {this.renderSelect("account", "Account", this.state.accounts)}
              {this.renderInput("amount", "Amount", "text")}
              {this.renderInput("description", "Description", "text")}
              <Table.Cell width="8">
                <div>Attachment</div>
                <input
                  className="input_imagem_artigo"
                  type="file"
                  onChange={this.onChangeFile}
                />
              </Table.Cell>

              {this.renderButton("Save")}
            </div>
          </div>
        </form>
      </BlockUi>
    );
  }
}

export default GeneralLedgerEntry;
